/* eslint-disable */

import Swiper from 'swiper/bundle';

var swiper = new Swiper('.swiper-container', {
  direction: 'horizontal',
  slidesPerView: 1.3,
  spaceBetween: 30,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    480: {
      slidesPerView: 2.1,
    },
    991: {
      slidesPerView: 3.1,
    },
    1200: {
      slidesPerView: 4.1,
    }
  }
});


var swiper2 = new Swiper('.swiper-container2', {
  direction: 'horizontal',
  slidesPerView: 'auto',
  spaceBetween: 30,
  scrollbar: {
    // el: '.swiper-scrollbar',
    // hide: false,
    // draggable: true,
  },
  // breakpoints: {
  //   480: {
  //     slidesPerView: 4.1,
  //   },
  //   991: {
  //     slidesPerView: 5.1,
  //   },
  //   1200: {
  //     slidesPerView: 6.1,
  //   }
  // }
});



// WEBPACK FOOTER //
// ./scripts/swiper.js